import { UntypedFormGroup, NgForm } from "@angular/forms";

export class TCMFormHelper {

    constructor() {

    }
       /**
     * @param {?} ngForm
     * @param {?} formNativeElement
     * @param {?=} focusOnFirstInvalidControl
     * @return {?}
     */

       static invalidateForm(ngForm, formNativeElement, focusOnFirstInvalidControl = true) {
        /** @type {?} */
        const invalidControls = this.collectInvalidControls(ngForm);
        invalidControls.forEach((/**
         * @param {?} c
         * @return {?}
         */
        c => c.markAsTouched()));
        if (formNativeElement && focusOnFirstInvalidControl) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const firstInvalidElement = (/** @type {?} */ (formNativeElement.getElementsByClassName('invalid')[0]));
                if (firstInvalidElement) {
                    firstInvalidElement.focus();
                }
            }), 0);
        }
    }

    static collectInvalidControls(ngForm: NgForm) {
        /** @type {?} */
        const stack = [];
        /** @type {?} */
        const controls = [];
        
        var controlKeys = Object.keys(ngForm.controls);
        var map = controlKeys.map((/**
            * @param {?} k
            * @return {?}
            */
           k => ngForm.controls[k]))

        var filter = map.filter((/**
            * @param {?} x
            * @return {?}
            */
           x => x.invalid))
        stack.concat(filter);
        while (stack.length > 0) {
            /** @type {?} */
            const control = stack.pop();
            if (control instanceof UntypedFormGroup) {
                stack.concat(Object.keys(control.controls).map((/**
                 * @param {?} k
                 * @return {?}
                 */
                k => control.controls[k])).filter((/**
                 * @param {?} y
                 * @return {?}
                 */
                y => y.invalid)));
            }
            else {
                controls.push(control);
            }
        }
        return controls;
    }


}

